import CategoryActivity from './CategoryActivity';
import './CategoryActivity.scss';

export default CategoryActivity;